import type { CityConfig } from "../city-template/types";

export const yanktonConfig: CityConfig = {
  city: "Yankton",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "yankton",
  route: "/cities/yankton",
  title: "Emergency Passport Yankton, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Yankton, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Yankton residents, Missouri River tourism, Lewis & Clark Lake visitors, Mount Marty University students, and southeastern South Dakota travelers.",
  h1: "Emergency & Expedited Passport Services in Yankton, SD",
  heroSubtitle: "Mount Marty University study abroad program starting soon? Missouri River tourism conference in Canada in two weeks? Yankton County family planning a Lewis & Clark heritage trip? We help Yankton residents — from MMU students and faculty to river recreation professionals to multi-generational families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20panoramic%20view%20of%20the%20Missouri%20River%20at%20Yankton%20South%20Dakota%20with%20the%20Meridian%20Bridge%20arching%20across%20the%20wide%20blue%20waterway%2C%20lush%20green%20riverbanks%20and%20cottonwood%20trees%20along%20the%20shoreline%2C%20recreational%20boats%20on%20the%20water%2C%20warm%20golden%20hour%20sunlight%20casting%20reflections%20on%20the%20river%20surface%2C%20historic%20river%20town%20atmosphere%20with%20limestone%20bluffs%20in%20the%20distance%20under%20a%20vast%20prairie%20sky&width=1800&height=700&seq=yankton-hero-2026&orientation=landscape",
  heroImageAlt: "Missouri River and Meridian Bridge in Yankton South Dakota at golden hour",
  geoPosition: "42.8711;-97.3972",
  geoPlacename: "Yankton, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located approximately 300 miles northeast of Yankton via I-29 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Yankton", zips: "57078" },
    { name: "Vermillion", zips: "57069" },
    { name: "Gayville", zips: "57031" },
    { name: "Wakonda", zips: "57073" },
    { name: "Mission Hill", zips: "57046" },
    { name: "Lesterville", zips: "57040" },
    { name: "Tabor", zips: "57063" },
    { name: "Tyndall", zips: "57066" },
    { name: "Scotland", zips: "57059" },
    { name: "Springfield", zips: "57062" },
    { name: "Avon", zips: "57315" },
    { name: "Hartington, NE", zips: "68739" },
    { name: "Crofton, NE", zips: "68730" },
    { name: "Bloomfield, NE", zips: "68718" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Minneapolis Passport Agency — as fast as 24 hours for Yankton-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "Multi-Airport Access", desc: "FSD (Sioux Falls, 80 mi north) and SUX (Sioux City, IA, 65 mi southeast) provide dual regional airport options for international connections." },
    { icon: "ri-anchor-line", title: "Missouri River Recreation Hub", desc: "Lewis & Clark Lake, Gavins Point Dam, and the Missouri National Recreational River draw international visitors — we help Yankton residents travel abroad too." },
    { icon: "ri-graduation-cap-line", title: "Mount Marty University Support", desc: "MMU Lancer study abroad programs, mission trips, and faculty international conferences — we understand university timelines." },
  ],
  internalLinks: [
    { name: "Fast passport services in Sioux Falls, SD", route: "/cities/sioux-falls" },
    { name: "Expedited passport in Rapid City, SD", route: "/cities/rapid-city" },
    { name: "Quick passport services in Mitchell, SD", route: "/cities/mitchell" },
    { name: "Urgent passport services in Brookings, SD", route: "/cities/brookings" },
    { name: "South Dakota passport services overview", route: "/states/south-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Yankton via secure registered courier with direct access to the Minneapolis Passport Agency at 212 3rd Ave S, Minneapolis. Our registered couriers hand-deliver your documents — meaning you get faster results without the 300-mile drive. Yankton residents can ship from any UPS Store, FedEx Office, or post office location across Yankton County.",
  fpcOfficeDistance: "Serving Yankton, Vermillion, Gayville, Wakonda, Mission Hill, Tabor, and all Yankton County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Yankton and Yankton County. From the historic downtown riverfront district to the Mount Marty University campus, from the Lewis & Clark Lake recreation area to the surrounding agricultural communities — we serve all of Yankton County and adjacent areas. Our courier service eliminates the need to drive five hours to the Minneapolis Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Yankton and surrounding communities including Vermillion, Gayville, Wakonda, Mission Hill, Tabor, Tyndall, and Springfield. We also serve travelers departing from Sioux Falls Regional Airport (FSD) and Sioux Gateway Airport (SUX) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Yankton as simple as possible — with the efficiency and reliability MMU students, Missouri River tourism professionals, and Yankton County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Yankton travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Yankton travelers encounter unique passport issues — everything from Missouri River international conference travel to Lewis & Clark heritage trips to 6-month validity rules for European destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Yankton travelers — from MMU Lancers to river recreation business owners to Yankton County families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Yankton, SD? Here are the most common ones we hear from Yankton County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a Missouri River tourism conference in Canada, an emergency passport for a MMU mission trip, or a first-time passport for a family heritage trip to Europe — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "MMU mission trip leaving in 3 days? Missouri River tourism conference in Canada this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Yankton-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Yankton residents renew fast — no agency visit required for most renewals. Perfect for MMU faculty, river recreation professionals, and Yankton County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Yankton residents through every step — from MMU freshmen to river business owners — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your river tourism conference or MMU trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip abroad or Lewis & Clark heritage tour stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Yankton residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Yankton business owners and MMU professors who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Yankton-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Yankton SD", description: "Urgent passport processing for Yankton South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Yankton SD", description: "Fast passport renewal for Yankton South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Yankton SD", description: "New passport application services for Yankton South Dakota residents applying for their first passport." },
    { name: "Child Passport Yankton SD", description: "Minor passport services for Yankton South Dakota families with children under 16." },
    { name: "Name Change Passport Yankton SD", description: "Passport name correction after marriage, divorce, or legal name changes for Yankton residents." },
    { name: "Second Passport Yankton SD", description: "Second passport services for Yankton business owners and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Karen T.",
      location: "MMU Student, Yankton",
      rating: 5,
      text: "I got accepted to a nursing mission trip to Honduras with only 3 weeks before departure. I had never had a passport. Fast Passport Center walked me through everything and it arrived with 4 days to spare. Incredible!",
      service: "First-Time Passport",
    },
    {
      name: "Mike R.",
      location: "River Guide, Yankton",
      rating: 5,
      text: "I needed to attend a river recreation conference in Canada and my passport expired during the busy summer season. They got me renewed in 5 days. Didn't miss a single session.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Weber Family",
      location: "Yankton County",
      rating: 5,
      text: "We booked a Lewis & Clark heritage trip following the expedition trail across multiple European connections. Our youngest needed a first passport and they handled it beautifully. We all made the trip together.",
      service: "Child Passport",
    },
    {
      name: "Tom H.",
      location: "Business Owner, Yankton",
      rating: 5,
      text: "Second time using Fast Passport Center for international sourcing trips. The document review caught an error on my application that would have caused weeks of delay. Won't use anyone else.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "yankton-1",
      name: "Yankton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "506 W 25th St",
      city: "Yankton",
      state: "SD",
      zip: "57078",
      phone: "(605) 665-2567",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Yankton",
      website: "https://tools.usps.com/find-location.htm?location=1368583",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Yankton and Yankton County. Passport photos available. Appointment strongly recommended — limited walk-in capacity especially during summer tourist season.",
      icon: "ri-mail-line",
    },
    {
      id: "yankton-2",
      name: "Yankton County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "410 Walnut St",
      city: "Yankton",
      state: "SD",
      zip: "57078",
      phone: "(605) 260-4400",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Yankton County Courthouse",
      website: "https://www.co.yankton.sd.us/",
      websiteLabel: "Yankton County",
      notes: "County clerk office offering passport acceptance services. Convenient for downtown Yankton residents and MMU students. Call ahead to confirm clerk availability.",
      icon: "ri-government-line",
    },
    {
      id: "yankton-3",
      name: "Vermillion Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16 N Dakota St",
      city: "Vermillion",
      state: "SD",
      zip: "57069",
      phone: "(605) 624-4501",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Vermillion — 26 miles east",
      website: "https://tools.usps.com/find-location.htm?location=1368547",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility serving Clay County including USD students and Vermillion residents. Passport photos available. Convenient for southeastern Yankton County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "yankton-4",
      name: "Sioux City Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 Nebraska St",
      city: "Sioux City",
      state: "IA",
      zip: "51101",
      phone: "(712) 277-6301",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux City, IA — 65 miles southeast",
      website: "https://tools.usps.com/find-location.htm?location=1368204",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility across the border in Iowa. Full photo services. Larger facility with more appointment availability than rural South Dakota post offices. Near Sioux Gateway Airport (SUX).",
      icon: "ri-mail-line",
    },
    {
      id: "yankton-5",
      name: "Tyndall Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1709 Main St",
      city: "Tyndall",
      state: "SD",
      zip: "57066",
      phone: "(605) 589-3531",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Tyndall — 20 miles west",
      website: "https://tools.usps.com/find-location.htm?location=1368537",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Bon Homme County residents. Limited hours — call ahead to confirm availability and photo services.",
      icon: "ri-mail-line",
    },
    {
      id: "yankton-6",
      name: "Sioux Falls Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 S 2nd Ave",
      city: "Sioux Falls",
      state: "SD",
      zip: "57104",
      phone: "(605) 336-3343",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux Falls — 80 miles north via US-81",
      website: "https://tools.usps.com/find-location.htm?location=1368468",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region. Full photo services and more appointment availability than smaller rural post offices. Worth the drive for guaranteed service.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 300 miles to Minneapolis Passport Agency", fpc: "Most Yankton travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no Missouri River, MMU, or southeastern SD expertise", fpc: "Full MMU/river tourism/Yankton County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Underestimating Cross-Border Travel Documents",
      description: "Yankton residents crossing into Nebraska or Iowa may think they do not need a passport, but any international travel (including Canada and Mexico) requires one. We clarify requirements before you travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Yankton applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Yankton pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Yankton County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Summer Tourist Season Rush",
      description: "Yankton's summer tourism season (Lewis & Clark Lake, river recreation) creates peak passport demand in May–June. Applicants often underestimate processing times during this period. We offer expedited options to bypass the backlog.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Yankton clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 300 miles to Minneapolis or wait at a rural post office." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Yankton?", a: "We offer Yankton-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Yankton?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Yankton post office or county clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Yankton address." },
    { q: "Where can I get passport acceptance in Yankton?", a: "Yankton has passport acceptance at the Main Post Office (506 W 25th St) and the Yankton County Clerk of Courts (410 Walnut St). Nearby options include post offices in Vermillion, Tyndall, Sioux City (IA), and Sioux Falls." },
    { q: "Can I use Sioux City airport for international travel from Yankton?", a: "Yes. Sioux Gateway Airport (SUX) in Sioux City, Iowa is 65 miles southeast with connections to major hubs. Sioux Falls Regional Airport (FSD) is 80 miles north. Both provide access to international gateways. We can coordinate passport processing timelines with either airport." },
    { q: "Can MMU students get expedited passports?", a: "Yes. Mount Marty University Lancers participating in mission trips, study abroad, or international service learning can use our expedited courier service. We understand university timelines and can process first-time and renewal passports before program departure dates." },
    { q: "What documents do Yankton applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Yankton-specific checklist." },
    { q: "Can I get a passport photo in Yankton?", a: "Yes — the Yankton Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and Walgreens. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How far is the nearest passport agency from Yankton?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 300 miles northeast via I-29. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "How do I check my Yankton passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Yankton to final return shipping typically matches your chosen speed tier." },
    { q: "Does Lewis & Clark Lake tourism create passport demand?", a: "Yes. The Missouri National Recreational River and Lewis & Clark Lake draw international visitors, and many Yankton residents in the tourism and recreation industry travel abroad for conferences, trade shows, and sister-river exchanges. We understand this seasonal industry's timeline." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Yankton Residents",
    intro: "Yankton's position on the Missouri River as a historic river town and gateway to Lewis & Clark Lake recreation creates unique passport timing challenges. Here's what Yankton travelers need to know.",
    cards: [
      {
        icon: "ri-anchor-line",
        title: "Missouri River Tourism & Recreation Industry",
        subtitle: "Lewis & Clark Lake, Gavins Point Dam, and the Missouri National Recreational River",
        description: "Yankton's identity as a Missouri River destination creates international tourism connections. River recreation professionals attend international conferences, sister-river exchange programs bring European waterway managers to Yankton, and tourism industry professionals travel to Canada for outdoor recreation trade shows. The summer tourism season (May–September) creates a compressed window for international travel planning.",
        tip: "Yankton tourism professionals should check passport validity in the off-season (October–March) when business is slower and processing times are more predictable.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Dual Airport Strategy — FSD & SUX",
        subtitle: "Two regional airports within driving distance",
        description: "Yankton residents benefit from two regional airports: Sioux Falls Regional Airport (FSD, 80 miles north) and Sioux Gateway Airport in Sioux City, Iowa (SUX, 65 miles southeast). Both offer connections through major hubs. Having two options gives Yankton travelers flexibility when booking international connections — compare fares and schedules between FSD and SUX.",
        tip: "Check flight schedules from both FSD and SUX when planning international trips. SUX sometimes offers better connections through Chicago, while FSD has more frequency through Minneapolis.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Mount Marty University International Programs",
        subtitle: "MMU mission trips, nursing study abroad, and service learning",
        description: "Mount Marty University's Benedictine tradition emphasizes service, and many MMU students participate in international mission trips to Central America, Africa, and the Caribbean. The nursing program occasionally offers clinical experiences abroad. Most MMU students are first-time passport applicants applying just weeks before departure — requiring expedited processing to meet program timelines.",
        tip: "MMU students: apply for your passport the moment you commit to a trip — not when the packing list arrives. First-time applications need an acceptance facility visit plus processing time.",
      },
      {
        icon: "ri-road-map-line",
        title: "Lewis & Clark Heritage Travel",
        subtitle: "Following the Corps of Discovery trail across multiple states and countries",
        description: "Yankton's significance on the Lewis & Clark expedition trail — the Corps camped near present-day Yankton in 1804 — creates heritage tourism interest. Many Yankton families plan heritage trips following the Lewis & Clark trail, which spans the U.S. and includes connections to European destinations significant to the expedition's history. These multi-destination trips often require passports for international segments.",
        tip: "Heritage trail trips spanning multiple countries require careful passport and visa planning. Start the passport process at least 3 months before departure for complex multi-country itineraries.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Yankton & Cross-Border Nebraska/Iowa Commerce",
      description: "Yankton's location at the tri-state border of South Dakota, Nebraska, and Iowa creates regular cross-border travel. While domestic crossings do not require passports, many Yankton business owners and professionals with clients across state lines also travel internationally — and discover expired passports at the worst moment.",
    },
  },
  destinations: {
    title: "Where Yankton Travelers Go — And Why Passports Get Urgent",
    intro: "Yankton's unique mix of river recreation, university travel, and heritage tourism creates diverse passport needs. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "30%", label: "of Yankton expedited requests are MMU mission trip or study abroad-related" },
      { stat: "2–4 Weeks", label: "average lead time for tourism industry professionals attending international conferences" },
      { stat: "May–Jul", label: "peak season when summer tourism, family vacations, and MMU summer programs overlap" },
      { stat: "300 Miles", label: "distance Yankton residents avoid by using our courier instead of driving to the Minneapolis agency" },
    ],
    destinations: [
      { name: "Honduras & Guatemala", context: "MMU nursing and education mission trips, healthcare service learning, community development", urgency: "Mission trip deadlines with 4–8 week advance notice", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Outdoor recreation trade shows, river management conferences, fishing trips to Manitoba and Ontario", urgency: "Summer conference season May–August, passport card popular", icon: "ri-map-pin-2-line" },
      { name: "Germany & Austria", context: "Sister-river exchange programs, European waterway management, Danube-Rhine river industry", urgency: "Conference dates fixed — 2–3 month planning typical", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "Lewis & Clark heritage connections, MMU Benedictine exchange programs, family roots travel", urgency: "Summer heritage trips booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter getaways from South Dakota cold, Cancun resort packages, cruise departures from Gulf Coast", urgency: "Last-minute resort deals booked 3–4 weeks out during January–March", icon: "ri-map-pin-2-line" },
      { name: "Netherlands", context: "Dutch heritage roots strong in southeastern South Dakota, water management exchange programs", urgency: "Summer family heritage trips booked 3–4 months in advance", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Sioux Falls", route: "/cities/sioux-falls" },
      { name: "Rapid City", route: "/cities/rapid-city" },
      { name: "Mitchell", route: "/cities/mitchell" },
    ],
  },
  photoLocations: [
    { name: "Yankton Main Post Office", address: "506 W 25th St, Yankton, SD 57078", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Yankton", address: "2100 Broadway Ave, Yankton, SD 57078", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Yankton", address: "3001 Broadway Ave, Yankton, SD 57078", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Yankton", address: "802 Broadway Ave, Yankton, SD 57078", hours: "Daily 8 AM – 10 PM" },
    { name: "UPS Store — Yankton", address: "2101 Broadway Ave, Yankton, SD 57078", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Vermillion Post Office", address: "16 N Dakota St, Vermillion, SD 57069", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walgreens — Sioux City", address: "4650 Morningside Ave, Sioux City, IA 51106", hours: "Daily 8 AM – 10 PM" },
    { name: "FedEx Office — Sioux Falls", address: "3400 W 49th St, Sioux Falls, SD 57106", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Yankton DPS Driver License Exam Station",
      address: "3113 Spruce St, Yankton, SD 57078",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Driver licenses, REAL ID, written and road tests. Appointment recommended.",
      featured: true,
    },
    {
      name: "Sioux Falls DPS Driver License Exam Station",
      address: "3101 W Russell St, Sioux Falls, SD 57107",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving Minnehaha County. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport (Joe Foss Field)",
      distance: "About 80 miles north of Yankton via US-81 and I-29",
      address: "2801 N Jaycee Ln, Sioux Falls, SD 57104",
      note: "Primary airport for eastern South Dakota. Daily nonstop connections to MSP, ORD, and DEN — all major international gateways. About a 75-minute drive from Yankton.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "FSD Airport Website",
      featured: true,
    },
    {
      code: "SUX",
      name: "Sioux Gateway Airport",
      distance: "About 65 miles southeast of Yankton via US-81 and I-29",
      address: "2403 Aviation Blvd, Sioux City, IA 51111",
      note: "Regional airport serving Sioux City, Iowa area with connections to ORD and DEN. Convenient alternative for southeastern Yankton County residents. About a 60-minute drive.",
      flightUrl: "https://www.flysux.com/",
      flightLabel: "SUX Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Yankton County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.co.yankton.sd.us/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Yankton County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.co.yankton.sd.us/departments/clerk-of-courts",
    },
  ],
};